import {apiUrl, alert} from '../helper'
import $ from 'jquery'

export default {
  data () {
    return {
      // uidUrl: null, //url中的uid参选参数值，用户id
      showmenu: false, //目录
      showAllTitle: false,   // 公告大标题是否全显示
    }
  },
  methods: {
    //点击目录标题
    titleIntoView (id) {
      this.toggleMenu()
      if (!this.showmenu) {
        this.$nextTick(function () {
          document.getElementById(id).scrollIntoView()
        })
      }
    },
    genTitleTree (titles) {
      this.titles = titles
    },
    //展开二级目录
    showTitleChild (title) {
      let code = title.code
      title.showchild = !title.showchild
      let rgxp = new RegExp('^' + code + '\.\\d+$', 'g')
      if (!title.showchild) {
        rgxp = new RegExp('^' + code + '(\.\\d+)+$', 'g')
      }
      for (let t of this.titles) {
        if (t.code && t.code.match(rgxp)) {
          t.isshow = title.showchild
        }
      }
    },
    //切换目录
    toggleMenu () {
      console.log('toggleMenu')
      if (this.showmenu) {
        this.showmenu = false
      } else {
        this.showmenu = true
      }
    },
    //点击切换标题
    toggleTitle () {
      console.log('toggleTitle')
      // 当字符超过33个时只显示前33个
      let title = this.detail.fulltitle
      let titltLen = title.length
      console.log(titltLen)
      if (titltLen <= 33) {   // 标题字符长度小于33个
        return
      } else {
        if (!this.showAllTitle) {  // 打开
          console.log('打开')
          let newTitle = this.detail.fulltitle
          $('#detail-title').html(newTitle)
          this.showAllTitle = true
          // 切换箭头图标样式
          $('.toggle-icon').removeClass('toggle-down-arrow').addClass('toggle-up-arrow')
        } else {   // 关闭
          // 截取前33个字符
          console.log('关闭')
          let newTitle = this.detail.fulltitle.replace(/(^\s*)|(\s*$)/g, '').substr(0, 20) + '...'   // 前50个字符
          $('#detail-title').html(newTitle)
          this.showAllTitle = false
          // 切换箭头图标样式
          $('.toggle-icon').removeClass('toggle-up-arrow').addClass('toggle-down-arrow')
        }
      }
    },
    //隐藏导引
    hideNewUserGuide () {
      this.showguide = false
    },
  },
  filters: {
    formatTitle (param) {
       // 如果公告标题大于33个字符长度
      if (param !== undefined) {
        if (param.length > 20) {
          param = param.replace(/(^\s*)|(\s*$)/g, '').substr(0, 20) + '...'
          return param
        } else {
          return param
        }
      }
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/common/noticeMix.js
 **/